export default {
  mixins: {
    data: function() {
      return {
        sites: [
          {
            avatar: 'https://rochester.kidsoutandabout.com/sites/all/themes/koaa_responsive/logo.png',
            title: 'Kids Out And About',
            subtitle: "To provide parents with all of the information they need to help them and their kids get 'out and about' to fantastic opportunities for fun, education, and cultural enrichment in our area.",
            domain: 'kidsoutandabout.com',
            label: 'KidsOutAndAbout.com: Family-friendly events & activities'
          },
          {
            avatar: 'https://rochester.beyondthenest.com/sites/all/themes/koaa_responsive_btn/logo.png',
            title: 'Beyond The Nest',
            subtitle: "To celebrate and share information on the many splendid artistic, cultural and recreational activities available to residents of cities across the US and Canada.",
            domain: 'beyondthenest.com',
            label: 'BeyondTheNest.com: Arts, culture, and recreation for grownups'
          },
        ],
      }
    }
  },
  create: function (Vue) {
    Vue.mixin(this.mixins);
  }
}
